/**
 * Projects Portfolio — client-side filtering
 * Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  var SECTION_SEL = '.projects-portfolio';
  var FILTER_BTN_SEL = '.projects-portfolio__filter-btn';
  var CARD_SEL = '.projects-portfolio__card';
  var COUNTER_SEL = '.projects-portfolio__count';
  var EMPTY_SEL = '.projects-portfolio__empty';

  function init() {
    var section = document.querySelector(SECTION_SEL);
    if (!section) return;

    var buttons = section.querySelectorAll(FILTER_BTN_SEL);
    var cards = section.querySelectorAll(CARD_SEL);
    var counter = section.querySelector(COUNTER_SEL);
    var empty = section.querySelector(EMPTY_SEL);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-filter-group');
        var value = btn.getAttribute('data-filter-value');

        // Toggle active state within the same group
        var groupButtons = section.querySelectorAll(
          FILTER_BTN_SEL + '[data-filter-group="' + group + '"]'
        );

        if (value === 'all') {
          // "All" resets the group
          groupButtons.forEach(function (b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');
        } else {
          // Deactivate the "All" button in this group
          var allBtn = section.querySelector(
            FILTER_BTN_SEL + '[data-filter-group="' + group + '"][data-filter-value="all"]'
          );
          if (allBtn) allBtn.classList.remove('active');

          // Toggle this button
          btn.classList.toggle('active');

          // If nothing is active, re-activate "All"
          var anyActive = section.querySelector(
            FILTER_BTN_SEL + '[data-filter-group="' + group + '"].active:not([data-filter-value="all"])'
          );
          if (!anyActive && allBtn) {
            allBtn.classList.add('active');
          }
        }

        filterCards(section, cards, counter, empty);
      });
    });
  }

  function getActiveFilters(section) {
    var filters = {};
    var activeButtons = section.querySelectorAll(FILTER_BTN_SEL + '.active');

    activeButtons.forEach(function (btn) {
      var group = btn.getAttribute('data-filter-group');
      var value = btn.getAttribute('data-filter-value');
      if (value === 'all') return;

      if (!filters[group]) filters[group] = [];
      filters[group].push(value);
    });

    return filters;
  }

  function filterCards(section, cards, counter, empty) {
    var filters = getActiveFilters(section);
    var visibleCount = 0;

    cards.forEach(function (card) {
      var show = true;

      // AND logic between groups, OR logic within a group
      for (var group in filters) {
        var cardValue = card.getAttribute('data-' + group);
        if (!cardValue) {
          show = false;
          break;
        }
        // Support comma-separated values on the card
        var cardValues = cardValue.split(',').map(function (v) { return v.trim().toLowerCase(); });
        var match = filters[group].some(function (f) {
          var filterVal = f.toLowerCase();
          if (group === 'style') {
            // Fuzzy match: filter value is a substring of any card style value
            return cardValues.some(function (cv) {
              return cv.indexOf(filterVal) !== -1;
            });
          }
          return cardValues.indexOf(filterVal) !== -1;
        });
        if (!match) {
          show = false;
          break;
        }
      }

      if (show) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (counter) {
      counter.textContent = visibleCount + ' project' + (visibleCount !== 1 ? 's' : '');
    }
    if (empty) {
      empty.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  }

  // Init on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
